import React from 'react';
import Button from 'components/control/button';
import styles from './style.module.scss';
import { blurIds } from 'constants/test-constants';
import { buildClassName } from 'utils/build-class-name';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

export type CompliancyDisclaimerProps = {
  message: string;
  buttonLabel: string;
};

const CompliancyDisclaimer = ({ message, buttonLabel } : CompliancyDisclaimerProps) => { 
  return (
    <div className={buildClassName(styles.component, styles['component-small'])}>
      <p className={styles.disclaimer} data-testid={blurIds.overlaySignInMsg}>{message}</p>
      <Button theme="secondary" className={styles['cta-button']} testId={blurIds.overlaySignInBtn} label={buttonLabel} />
    </div>
  );
};

export const LoginRequired = () => {
  const { t } = useTranslation(Namespaces.COMMON);
  
  const message = t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_OVERLAY_SIGN_IN_MESSAGE, {
    defaultValue: 'Real estate boards require that you sign in to see listing details',
  });
  
  const buttonLabel = t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_SIGN_IN_BUTTON_SHORT, {
    defaultValue: 'Sign In',
  });
  
  return (
    <>
      <CompliancyDisclaimer message={message} buttonLabel={buttonLabel} />
    </>
  );
};

export const TermsOfUseRequired = () => {
  const { t } = useTranslation(Namespaces.COMMON);
  
  const message = t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_OVERLAY_TERMS_OF_USE_MESSAGE, {
    defaultValue: 'Accept Terms of Use to see listing details',
  });
  
  const buttonLabel = t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_TERMS_BUTTON_SHORT, {
    defaultValue: 'View',
  });
  
  return (
    <>
      <CompliancyDisclaimer message={message} buttonLabel={buttonLabel} />
    </>
  );
};

export default CompliancyDisclaimer;